import * as yup from 'yup';
import { API } from '../../suppliers/api';
import { AvailableType } from '../../listItem/conf/Data.conf';
import { StatusLogbookDeliveries } from '../../logbook/conf/Data.conf';

export const FilterConf = {
  schema: yup.object({
    id_supplier: yup.object().nullable(),
    available: yup.array().nullable(),
    status_logbook: yup.array().nullable(),
  }),
  initialState: {
    value: {
      id_supplier: null,
      available: null,
      status_logbook: null,
    },
  },
  fields: [
    {
      id: 'id_supplier',
      name: 'id_supplier',
      type: 'async_autocomplete',
      label: 'Supplier',
      api: API.select,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'available',
      name: 'available',
      type: 'autocomplete_multiple',
      label: 'Available',
      options: AvailableType?.map((item) => ({
        id: item?.id,
        label: item?.label,
      })),
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status_logbook',
      name: 'status_logbook',
      type: 'autocomplete_multiple',
      label: 'Status',
      options: StatusLogbookDeliveries,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
  ],
  query: {
    keys: [
      {
        key: 'id_logbook.id_supplier.id',
        value: 'id_supplier.id',
        operator: '$eq',
      },
      {
        key: 'available',
        value: 'available.id',
        operator: '$eq',
      },
      {
        key: 'id_logbook.status_logbook',
        value: 'status_logbook.label',
        operator: '$eq',
      },
    ],
  },
};
